import { render, staticRenderFns } from "./AppFooterAttente.html?vue&type=template&id=2ee7f7ea&scoped=true&"
import script from "./AppFooterAttente.vue?vue&type=script&lang=js&"
export * from "./AppFooterAttente.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterAttente.scss?vue&type=style&index=0&id=2ee7f7ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7f7ea",
  null
  
)

export default component.exports